import React, { useEffect, useState, useCallback } from 'react'
import { updateObject, checkValidity } from '../../../shared/utility'
import FormsInput from '../../Ui/FormsInput';
import Buttons from '../../Ui/buttons/Buttons';
import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import * as actions from '../../../store/actions/index'
import { useDispatch, useSelector } from 'react-redux'
import ImageGallery from 'react-image-gallery'
import { formatDistance } from 'date-fns';

const baseUrl = process.env.PUBLIC_URL;

const ViewProduct = (props) => {

    const [colorID, setcolorID] = useState(0)
    const [formIsValid, setValid] = useState(false)
    const [priceForm, setPriceForm] = useState({
        color: {
            elementType: 'select',
            variant: 'outlined',
            label: 'Available Colours:',
            name: 'color',
            elementConfig: {
                required: true,
                options: []
            },
            touched: false,
            value: '',
            classname: 'col-md-12 mt-3',
            validation: {
                type: 'select',
                required: true,
                minLength: 1,
                maxLength: 100
            },
            invalid: {
                isValid: true,
                isValidMessage: ''
            },
        },
        qty: {
            elementType: 'select',
            variant: 'outlined',
            label: 'Quantity',
            name: 'qty',
            elementConfig: {
                required: true,
                options: []
            },
            value: '1',
            classname: 'col-md-12 mt-3',
            validation: {
                type: 'select',
                required: true,
                minLength: 1,
                maxLength: 100
            },
            invalid: {
                isValid: true,
                isValidMessage: ''
            },
        }
    })
    const [questionForm, setQuestionForm] = useState({
        name: {
            elementType: 'input',
            variant: 'outlined',
            label: 'Name',
            name: 'name',
            elementConfig: {
                required: true,
            },
            value: '',
            classname: 'col-md-12 mt-4',
            validation: {
                type: 'select',
                required: true,
                minLength: 3,
                maxLength: 100
            },
        },
        email: {
            elementType: 'input',
            variant: 'outlined',
            label: 'Email',
            name: 'email',
            elementConfig: {
                required: true,
            },
            value: '',
            classname: 'col-md-12 mt-4',
            validation: {
                type: 'select',
                required: true,
                minLength: 3,
                maxLength: 100
            },
        },
        question: {
            elementType: 'multiline',
            variant: 'outlined',
            label: 'Question',
            name: 'question',
            elementConfig: {
                required: true,
            },
            value: '',
            classname: 'col-md-12 mt-4',
            validation: {
                type: 'select',
                required: true,
                minLength: 3,
                maxLength: 100
            },
        },

    })
    const [allImg, setImg] =useState([])
    const dispatch = useDispatch();
    const formElementsArray = []
    const formContactArray = []
    const paramsCategory = props.match.params.category
    const paramsId = props.match.params.id

    const isAuth = useSelector(state => state.auth.token !== null)
    const product = useSelector(state => state.product.product);
    const loading = useSelector(state => state.product.loading);
    const currentPrice = useSelector(state => state.product.currentPrice)
    const currentDeliveryPeriod = useSelector(state => state.product.currentDeliveryPeriod)
    const currentDeliveryFee = useSelector(state => state.product.currentDeliveryFee)
    const currentQty = useSelector(state => state.product.currentQty)
    const onSetCurrentState = (price, period,fee, qty) => dispatch(actions.setCurrentState(price,period, fee, qty))
    const onAddtoCartServices = (product, color, qty) => dispatch(actions.addCartService(product, color, qty))
    const onFetchProduct = (category, id) => dispatch(actions.fetchProduct(category, id))

    useEffect(() => {
        onFetchProduct(paramsCategory, paramsId)
    }, [])

    useEffect(()=>{
        if(product){
            let attOptions = []
            let attQty = []
            let imgs = []
            let qty = ''
            const UpdateForm = {...priceForm}
            product.product_main_images.map((d) => (
                imgs.push({ original: d, thumbnail: d })
            ))
    
            product.attributes.map((d) => {
                if (d.product_status === 'active') {
                    d.product_sub_images_url.map(img => {
                        imgs.push({ original: img, thumbnail: img })
                    })
                    attOptions.push({ value: d.product_color, displayValue: d.product_color, id: d.id, price: d.product_price, delieverFee: d.product_delivery_fee, period:d.product_delivery_period,qty:d.product_quantity })
                    qty = parseInt(d.product_quantity)
                }
            })
            for (var x = 0; x < qty; x++) {
                attQty.push({ value: x + 1, displayValue: x + 1 })
            }

            UpdateForm["qty"].elementConfig.options = attQty
            UpdateForm["color"].elementConfig.options = attOptions
            setPriceForm(UpdateForm)
            setImg(imgs)
        }

    },[product])


   

    const inputChangedHandler = (event, controlName) => {
        let formIsValid = true
        let qty
        let attQty = []
        const updatedControls = {...priceForm}

        if (controlName === 'color'){
            priceForm["color"].elementConfig.options.map(d => {
                if (d.value === event.target.value) {
                    setcolorID(d.id)
                    onSetCurrentState(d.price,d.period, d.delieverFee, d.qty)
                    qty = parseInt(d.qty)
                }
            })
            for (var x = 0; x < qty; x++) {
                attQty.push({ value: x + 1, displayValue: x + 1 })
            }
            updatedControls["qty"].elementConfig.options = attQty
        }
        priceForm[controlName].value =  event.target.value
        priceForm[controlName].valid =checkValidity(event.target.value,priceForm[controlName].validation)
        priceForm[controlName].touched = true
        
        // const updatedControls = updateObject(priceForm, {
        //     [controlName]: updateObject(priceForm[controlName], {
        //         value: event.target.value,
        //         valid: checkValidity(
        //             event.target.value,
        //             priceForm[controlName].validation
        //         ),
        //         touched: true
        //     })
        // })

        // validation for each input
        for (let inputIdentifier in updatedControls) {
            if (updatedControls[inputIdentifier].invalid !== undefined) {
                formIsValid = updatedControls[inputIdentifier].invalid.isValid && formIsValid;
            }
        }
        setValid(formIsValid)
        setPriceForm(updatedControls)
    }

    const handleURL = (url) => {
        props.history.push({
            pathname: `${baseUrl}/${url}/`,
        })
    }


    for (let key in priceForm) {
        formElementsArray.push({
            id: key,
            config: priceForm[key]
        });
    }

  
    for (let key in questionForm) {
        formContactArray.push({
            id: key,
            config: questionForm[key]
        })
    }

    let form = priceForm["color"].elementConfig.options.length > 0 ?
    formElementsArray.map(formElement => (
        <FormsInput
            key={formElement.id}
            elementType={formElement.config.elementType}
            elementConfig={formElement.config.elementConfig}
            classname={formElement.config.classname}
            label={formElement.config.label}
            value={formElement.config.value}
            invalid={!formElement.config.valid}
            shouldValidate={formElement.config.validation}
            touched={formElement.config.touched}
            changed={event => inputChangedHandler(event, formElement.id)}
        />
    ))
    :
    <p className="mt-4">This product is currently unavailable</p>



    let contactForm = formContactArray.map(formElement => (
        <FormsInput
            key={formElement.id}
            elementType={formElement.config.elementType}
            elementConfig={formElement.config.elementConfig}
            classname={formElement.config.classname}
            label={formElement.config.label}
            value={formElement.config.value}
            invalid={!formElement.config.valid}
            shouldValidate={formElement.config.validation}
            touched={formElement.config.touched}
            changed={event => inputChangedHandler(event, formElement.id)}
        />
    ))


    return (
        !loading && product ?
            <Container fluid>
                <Row>
                    <Col sm={8} className="pr-0">
                        <ImageGallery
                            items={allImg}
                            thumbnailPosition={"bottom"}
                            showPlayButton={false}
                            showNav={false}
                        />
                        <Row>
                            <Container>
                                <Row className="mt-4">
                                    <Col md={12}>
                                        <h2>Product Information</h2>
                                        <h3 className="mt-4">{product.product_name}</h3>
                                        <span className="small-header">from {product.retailer_company_name}</span>
                                        <p>{product.product_long_description}</p>
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col md={12}> <h3>Product Specifications</h3></Col>
                                    <Col md={6}>
                                        <p>Length: <span className="sub-info"> {product.product_dimension.length}mm</span></p>
                                        <p>Height: <span className="sub-info"> {product.product_dimension.height}mm</span></p>
                                        <p>Width: <span className="sub-info"> {product.product_dimension.width}mm</span></p>
                                    </Col>
                                    <Col md={6}>
                                        <p>Weight: <span className="sub-info"> {product.product_weight}kg</span></p>
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col md={12}> <h3>Product Contact information</h3></Col>
                                    <Col md={6}>
                                        Ask a question
                                        {contactForm}
                                    </Col>

                                </Row>

                            </Container>
                        </Row>
                    </Col>
                    <Col md={4} className="border-left">
                        <div className="sticky mt-4">
                            <h2>{product.product_name}</h2>
                            <span className="small-header">from {product.retailer_company_name}</span>
                            <Row className="mt-4">
                                <Col sm={12}>
                                    <h2 className="sub-info">${currentPrice}</h2>
                                </Col>
                                <Col sm={12}>{<p>{product.product_short_description}</p>}</Col>
                                <Col sm={12} className="mt-4 "><p><span className="strong">{currentQty}</span> in stock</p></Col>
                            </Row>
                            <Row className='mt-2'>
                                <Col sm={12} className="mt-4">
                                    <p>Delivery Period:</p>
                                    <p className="sub-info">{currentDeliveryPeriod}</p>
                                </Col>
                                <Col sm={12} className="mt-4">
                                    <p>Delivery Fee:</p>
                                    <p className="sub-info">${currentDeliveryFee}</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12}>
                                    {form}
                                </Col>
                            </Row>

                            <Row className='mt-2'>
                                <Col sm={12}>
                                    {
                                        isAuth ?
                                            <Buttons
                                                buttonType="primary"
                                                buttonAction={() => onAddtoCartServices(product, colorID, priceForm["qty"].value)}
                                                buttontext="Add to Cart"
                                                classInput="col-md-12 mt-4"
                                                disabled={!formIsValid}
                                            />
                                        : 
                                        <Buttons
                                                buttonType="primary"
                                                buttonAction={() => handleURL('login')}
                                                buttontext="Login"
                                                classInput="col-md-12 mt-4"
                                               
                                            />
                                    }

                                </Col>
                            </Row>
                        </div>



                    </Col>
                </Row>
            </Container>
            :
            ''
    )
}


export default (ViewProduct)
